import { get } from "lodash";
import { GENDER } from "utils/constants";

export const formatClientName = (project) =>
  [
    GENDER[get(project, "contact.user.gender")],
    get(project, "contact.user.firstname"),
    get(project, "contact.user.lastname"),
  ]
    .filter(Boolean)
    .join(" ");
